import httpClient from './httpClient'

const END_POINT = '/api/localizacions'

const getLocalizaciones = (slug) => httpClient.get(END_POINT, { params: { slug: slug } })

export {

    getLocalizaciones

}